/**
 * 결재 서명 한 행의 **차수(round)** 를 읽는 한 벌.
 *
 * 차수는 「1차 제출 → 반려 후 재제출이면 2차, 3차…」다. 값이 없는 옛 행은 **1차**로 본다 —
 * 이 기본값 규약이 shared `latestRoundSignatures`의 `roundOf`(`round ?? 1`)이고, 그것이 정본이다
 * (라운드 6에서 web 6곳의 `||1`/`??1` 혼재를 그 한 벌로 접었다).
 *
 * 그런데 **서명 하나의 round를 읽는 자리**가 그 뒤에도 둘로 남아 갈려 있었다:
 *   - `lib/reports.ts` `deriveApprovalProgress` — 「(N차)」 접미용, `?? 1`
 *   - `components/reports/sections/ApprovalHistorySection.tsx` — 이력 **전 차수** 그룹핑, `|| 1`
 *
 * `|| 1`은 `0`도 1로 바꾼다. 서버가 round를 1부터 쓰므로 오늘은 결과가 같지만, 두 자리가 같은 질문에
 * 다른 규칙을 쓰고 있다는 사실 자체가 다음 변경에서 갈라진다. 그래서 한 함수로 모은다.
 *
 * ⚠️ **왜 `lib/reports.ts`가 아니라 별 파일인가**: 그 모듈을 `vi.mock`하는 spec이 36개다. 팩토리 mock은
 * 부분 mock이 아니므로, 거기에 새 export를 얹으면 그 키를 팩토리에 적지 않은 **무관한 spec들이 통째로**
 * `No "signatureRound" export is defined on the mock`으로 죽는다. 순수 술어는 mock 대상 밖에 둔다.
 *
 * 후속: 이 접근자의 제자리는 shared `utils/approval-signatures.ts`(`roundOf`가 사는 파일)다. 그 파일이
 * 이번 갈래의 담당 범위 밖이라 web에 두었다 — shared로 올리면 서버도 같은 접근자를 쓸 수 있다.
 */
export function signatureRound(sig: { round?: number | null }): number {
  return sig.round ?? 1;
}
